import Swiper from 'swiper'
import { Autoplay, EffectFade } from 'swiper/modules'

const swiperFades = document.querySelectorAll('.swiper-fade')

let swiperCount = 0
function initSwiperFade() {
    if (!swiperFades.length) return
    swiperFades.forEach((swiperWrapper) => {
        const swiper = new Swiper(swiperWrapper, {
            init: false,
            modules: [EffectFade, Autoplay],
            loop: true,
            autoplay: {
                delay: 4000,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            draggable: false,
            allowTouchMove: false,
            speed: 2000,
        })
        swiperWrapper.swiper = swiper
    })

    // Delay slider start for 3 seconds
    swiperFades.forEach((swiperWrapper) => {
        setTimeout(function () {
            const swiper = swiperWrapper.swiper
            swiper.init() // Start the slider
        }, (1000 * swiperCount) / 2)

        swiperCount++
    })
}

document.addEventListener('DOMContentLoaded', function () {
    initSwiperFade()
})
